import axios from "axios";

const state = {
    monthlyDetail: [],
    detailUser: [],
    detailYear: new Date().getFullYear(),
    detailMonth: ("0" + (new Date().getMonth() + 1)).slice(-2),
    detailLoading: false,
}

const getters = {
    getMonthlyDetail(state) {
        return state.monthlyDetail
    },

    getDetailUser(state) {
        return state.detailUser
    }
}

const mutations = {
    set_monthly_detail(state, monthlyDetail ) {
        state.monthlyDetail = monthlyDetail
    },

    set_detail_loading(state, loading) {
        state.detailLoading = loading
    },

    set_detail_user(state, { detailUser }) {
        state.detailUser = detailUser
    },

    set_detail_year(state, year ) {
        state.detailYear = year
    },

    set_detail_month(state, month ) {
        state.detailMonth = month
    },
}

const actions = {
    async actionMonthlyDetail({ state, commit }, data) {
        if(data.emptyBeforeCreate) {
            commit('set_monthly_detail', [])
        }
        commit('set_detail_loading', true)

        await axios({ url: `/montly-log/${data.userId}/${state.detailYear}/${state.detailMonth}`, method: 'GET' })
            .then(resp => {
                const data = resp.data.data
                commit('set_monthly_detail', data)
            })
        commit('set_detail_loading', false)
    },

    actionDetailUser({ commit }, detailUser) {
        commit('set_detail_user', { detailUser })
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}

